module.exports = __webpack_public_path__ + "img/bus_disabled2.779fc276.svg";